import { render, staticRenderFns } from "./Subscription.vue?vue&type=template&id=493779f5&"
import script from "./Subscription.vue?vue&type=script&lang=js&"
export * from "./Subscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('493779f5')) {
      api.createRecord('493779f5', component.options)
    } else {
      api.reload('493779f5', component.options)
    }
    module.hot.accept("./Subscription.vue?vue&type=template&id=493779f5&", function () {
      api.rerender('493779f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ispforum/forum/Subscription.vue"
export default component.exports